import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThreeBirdsFlyingVideo } from "./ThreeBirdsFlyingVideo";
export const DropzoneOverlay = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "fixed inset-0 z-10 flex flex-col items-center justify-center bg-grey-1 text-grey-12",
        children: [
            /*#__PURE__*/ _jsx(ThreeBirdsFlyingVideo, {}),
            /*#__PURE__*/ _jsx("h1", {
                className: "mt-24 font-semibold text-grey-12",
                children: "Drop files anywhere to upload"
            })
        ]
    });
};
